module.exports = __webpack_public_path__ + "img/folder_small.3e66633.png";